import { b2cGet } from "zebdsh.login.authentication";
class ReportingClient {
    constructor(url) {
        this.url = url;
    }
    loadEmbedToken(languagePrefix, reportName, successCallback, failureCallback) {
        b2cGet(this.url + "/" + languagePrefix + "/reports/" + reportName + "/embedToken/", successCallback, failureCallback);
    }
}
export default ReportingClient;
